/* eslint-disable react/prop-types */
/**
 * ContentGroupsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import ContentGroupsContext from './content-groups-context'
import {
  fetchContentGroupByCode,
  fetchContentGroup
} from './content-groups-api'

export default function ContentGroupsProvider({ children }) {
  const state = {
    fetchContentGroupByCode,
    fetchContentGroup
  }
  return (
    <ContentGroupsContext.Provider value={state}>
      {children}
    </ContentGroupsContext.Provider>
  )
}
